import { selfAssignJob } from '../../../../services/popupApi';

export const api = {
  onOk: async (context) => {
    await selfAssignJob({ jobIds: context.selectedIds });
  },
};
